import {Pipe, PipeTransform} from '@angular/core';
import {MitgliedDto} from '@wba/models/dto/mitglied-dto';
import {DateUtils} from '@wba/utils/date.utils';


@Pipe({
    name: 'nameUndGeburtsdatum',
    pure: false,
    standalone: false
})
export class NameUndGeburtsdatumPipe implements PipeTransform {
  transform(mitglied: MitgliedDto): string {
    if (!mitglied) {
      return '';
    }
    return `${mitglied.vorname} ${mitglied.nachname} (${DateUtils.format(mitglied.geburtsdatum, 'YYYY-MM-DD', 'DD.MM.YYYY')})`;
  }
}
